var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1477_5586)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1477_5586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1477_5586)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 0C38.8089 0 50 11.1911 50 25C50 38.8089 38.8089 50 25 50C11.1911 50 0 38.8089 0 25C0 11.1911 11.1911 0 25 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7393 25L13.7572 31.6107L19.375 34.9143V38.7857L10.4715 33.5643V23.0679L13.7393 25ZM13.7393 18.3893V22.2411L10.4679 20.3071V16.4536L13.7393 14.5196L17.0268 16.4536L13.7411 18.3893H13.7393ZM21.7215 16.4536L24.9929 14.5196L28.2786 16.4536L24.9929 18.3893L21.7215 16.4536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1035 30.2411V26.3696L19.3749 28.3054V32.1571L16.1035 30.2411ZM21.7214 36.3018L24.9928 38.2375L28.2785 36.3018V40.1536L24.9928 42.0893L21.7214 40.1536V36.3018ZM32.9714 16.4536L36.2428 14.5196L39.5285 16.4536V20.3071L36.2428 22.2411V18.3893L32.9714 16.4536ZM36.2428 31.6107L36.2607 25L39.5303 23.0643V33.5625L30.6267 38.7839V34.9143L36.2428 31.6107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8964 30.2411L30.625 32.1571V28.3054L33.8964 26.3696V30.2411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8964 19.7589L33.9142 23.6304L28.2803 26.9339V33.5625L25.0107 35.4786L21.7392 33.5625V26.9357L16.1053 23.6304V19.7589L19.391 17.825L24.9892 21.1464L30.6232 17.825L33.9089 19.7589H33.8964ZM16.1035 13.1518L24.991 7.91071L33.8964 13.1518L30.6249 15.0857L24.9928 11.7643L19.3749 15.0857L16.1035 13.1518Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1477_5586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.9a595823e809da1fbba87a6cab9c7b29.svg";
export { ForwardRef as ReactComponent };